import { afterRenderEffect, computed, inject, Injectable, signal } from '@angular/core';
import { defer, finalize, Observable, take } from 'rxjs';
import { ToasterService } from '#services';

@Injectable()
export class WorkflowLoadFeedbackService {
  private _toaster = inject(ToasterService);
  private _pending = signal(0);
  private _errors = signal(new Map<object | string, string>());
  settled = computed(() => this._pending() === 0);

  constructor() {
    afterRenderEffect(() => {
      if (!this.settled() || this._errors().size === 0) return;
      const messages = new Set(this._errors().values());
      this._errors.set(new Map());
      messages.forEach(message => this._toaster.showError(message));
    });
  }

  track<T>(request: Observable<T>): Observable<T> {
    return defer(() => {
      this._pending.update(count => count + 1);
      return request.pipe(take(1), finalize(() => this._pending.update(count => count - 1)));
    });
  }

  reportError(key: object | string, message: string): void {
    this._errors.update(errors => new Map(errors).set(key, message));
  }

  clearError(key: object | string): void {
    this._errors.update(errors => {
      const remaining = new Map(errors);
      remaining.delete(key);
      return remaining;
    });
  }
}
